import { CardConfiguration } from "../../typings";
import { ComponentType } from "../../data";
import { Event } from "../../contracts";
import { ComponentTypeMapper } from "../ComponentTypeMapper";
import { EventsBySportIdRequest } from "sb-resp-lib";

export const mapEventComponent = (event: Event, cardConfig: CardConfiguration, isMiniCard: boolean): Event => {
    let currentSportId = cardConfig[event.sportId] ? event.sportId : "0";
    event.componentType = getComponentType(event, isMiniCard);

    if(event.type === EventsBySportIdRequest.EventTypesEnum.Fixture.toString()) {
        let cardType = cardConfig[currentSportId].cardType;
        event.cardType = cardType;
    }
    return event;
}

const getComponentType = (event: Event, isMiniCard: boolean): ComponentType => {
    return ComponentTypeMapper[event.type] ? ComponentTypeMapper[event.type](isMiniCard, event.isLive) : ComponentType.EventCard;
}